<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
            <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input clearable disabled v-model="form.name" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="tel">
              <el-input clearable disabled v-model="form.tel" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
            <el-col :span="12">
              <el-form-item label="体检日期" prop="examDate">
                <el-date-picker
                  v-model="form.examDate"
                  style="width: 100%;"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择体检日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体检项目" prop="examItem">
                <el-input clearable   placeholder="请输入体检项目" v-model="form.examItem" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="检查结果" prop="examResult">
                <el-select placeholder="请选择体检结果"  v-model="form.examResult" style="width: 100%" >
                <el-option
                  v-for="item in examResultList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
              
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体检单位" prop="examUnit">
                <el-input clearable placeholder="请输入体检单位"  v-model="form.examUnit" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            
          
            <el-col :span="14">
              <el-form-item label="备注" prop="remark">
                <el-input clearable  type="textarea" placeholder="请输入备注" v-model="form.remark" maxlength="500"></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right" v-if="model != 'view'">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
          {{ model == 'add' ? '提交' : '修改' }}
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
      </div>
    </div>
  </template>
  <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { getDictionary } from '@/api/common.js';
  import { saveHealthExam,updateHealthExam } from '@/api/nursingHome/healthData.js';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
      personData: {
        default: {},
      },
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        projectList: [],
        provideList: [],
        form: {
          examItem:"",
          examDate: '',
          examUnit: '',
          examResult: '',
        },
        formRules: {
          examItem: [{ required: true, message: '体检项目不能为空', trigger: 'blur' }],
          examUnit: [{ required: true, message: '体检单位不能为空', trigger: 'blur' }],
          examResult: [{ required: true, message: '检查结果不能为空', trigger: 'change' }],
          examDate: [{ required: true, message: '体检日期不能为空', trigger: 'change' }],
       
        },
        matetialList: [],
        deviceCategoryList: [],
        userList: [],
        deviceTypeIdList: [],
        deviceModelIdList: [],
        
        examResultList: [
        {
          dictKey: "0",
          dictValue: '正常',
        },
        {
          dictKey: "1",
          dictValue: '异常',
        },
        ],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      
      async initData() {
      getDictionary("nursinghome_follow_type").then((res) => {
        this.followTypeList = res.data
      })
      if(this.model != 'add') {
      this.form = Object.assign({},this.row)   
      }
      console.log("person",this.personData)
      this.form.name = this.personData.name
      this.form.elderlyId= this.personData.id
      this.form.nursinghomeId= this.personData.nursinghomeId
      this.form.tel= this.personData.tel
     
    },
      saveRecord() {
        if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveHealthExam(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateHealthExam(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  